import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  buildingHeatSourceField,
  ceeBuildingAreaQuantityField,
} from './common/buildingCommonFields';
import { genericUnitField, ghgCategoryField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';

export const ceeBuildingScope1Metadata = {
  displayName: msg({
    message: 'CEE Building Scope 1',
    context: 'Activity data schema name for CEE Building Scope 1',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    building_heat_source: buildingHeatSourceField,
    quantity: ceeBuildingAreaQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
